import { MessageCircle } from "lucide-react";
import { motion } from "framer-motion";

export default function WhatsAppButton() {
  return (
    <motion.a
      href="https://wa.me/919619613720?text=Hi%20SolarSoch%2C%20I%20want%20to%20know%20more%20about%20rooftop%20solar."
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-float-button"
      aria-label="Chat on WhatsApp"
      initial={{ scale: 0, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      transition={{ delay: 1.2, type: "spring", stiffness: 260, damping: 18 }}
      whileHover={{ scale: 1.1 }}
      whileTap={{ scale: 0.92 }}
      className="fixed z-40 right-4 bottom-24 md:bottom-6 md:right-6 w-13 h-13 p-3.5 rounded-full bg-brand text-gold shadow-[0_10px_30px_rgba(6,95,70,0.45)] sun-glow"
    >
      <MessageCircle size={24} strokeWidth={2.2} />
    </motion.a>
  );
}
